export enum TerminalParameterValueType {
  BOOL = 'BOOL',
  STRING = 'STRING',
  PORT = 'PORT',
  CB01 = 'CB01',
  RGB = 'RGB',
  IMG = 'IMG',
  CB = 'CB'
}
